import React from "react";
import { Target } from "lucide-react";
import { MetaColetivaStats } from "../types";

interface ControleTempoProps {
  metaColetiva: MetaColetivaStats;
}

export const ControleTempo: React.FC<ControleTempoProps> = ({
  metaColetiva,
}) => {
  return (
    <div className="rounded-lg border border-indigo-400/30 bg-slate-800/60 p-4 shadow-lg">
      <h3 className="mb-4 flex items-center justify-center gap-2 text-center text-sm font-bold text-indigo-300">
        <Target size={14} className="text-indigo-400" />
        CONTROLE DE TEMPO
      </h3>

      <div className="space-y-3">
        <div className="rounded-lg border border-indigo-400/20 bg-slate-700/40 p-3">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="mb-1 text-xs font-medium text-indigo-300">META</h4>
              <div className="text-xs text-indigo-200 opacity-75">Objetivo</div>
            </div>
            <div className="flex h-8 w-20 items-center justify-center rounded border border-indigo-400/40 bg-slate-800/50 text-center text-lg font-bold text-white">
              {metaColetiva.tempo}
            </div>
          </div>
        </div>

        <div className="rounded-lg border border-orange-400/20 bg-slate-700/40 p-3">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="mb-1 text-xs font-medium text-orange-300">
                ATUAL
              </h4>
              <div className="text-xs text-orange-200 opacity-75">
                Realizado
              </div>
            </div>
            <div className="flex h-8 w-20 items-center justify-center rounded border border-orange-400/40 bg-slate-800/50 text-center text-lg font-bold text-orange-300">
              {metaColetiva.tempoMetaSistema}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
